export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0,
            showTour: false,
            closable: false,
            tourData: [
                {
                    target: '#closabelDemo',
                    title: '禁用关闭图标',
                    content: '当closable为true时，header区域关闭图标隐藏',
                    position: 'right'
                }
            ]
        };
    }

    @bind
    startTour() {
        this.set({
            showTour: true,
            currentStep: 0
        });
    }

    @bind
    finishTour() {
        this.set({
            showTour: false
        });
    }
}